import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";

import PieChat from "../../../components/charts/rechart/PieChat";
import { BarChartNoPadding } from "../../../components/charts/rechart/BarChartNoPadding";
import { TripleBarCharts } from "../../../components/charts/rechart/TripleBarCharts";
import { getCurrentFormattedDate } from "../../../../utils/dateFormatter";
import { fetchBuyerDashboard } from "../../../../services/DashboardService";
import Loader from "../../../components/Loader";
import { convertRevenueData } from "../../../../utils/allFormatter";
import { useTranslation } from "react-i18next";


const BuyerDashboard = () => {
   const { t } = useTranslation();
  const [dasboardData, setDasboardData] = useState({});
  const [loading, setLoading] = useState(true);
  const [revenue, setRevenue] = useState([]);
  useEffect(() => {
    getDasboardData();
  }, []);

  const getDasboardData = () => {
    const todayDate = getCurrentFormattedDate();

    fetchBuyerDashboard({ from: "1970-01-01", to: todayDate })
      .then((res) => {
        const response = res?.data?.result;
        setDasboardData(response);
        const tempRevenue = convertRevenueData(response?.buyerprofilegraphs?.top3industrieslast4yrsrev);

        setRevenue(tempRevenue);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const cardArray = [
    {
      icon: <Icon icon="ic:sharp-ads-click" className="currency-icon p-1" fontSize={60} color="#EB8153" />,
      value: dasboardData?.numberofsavedbusinesses ?? 0,
      title: `${t("hbusinessads")}`,
    },
    {
      icon: <Icon icon="iconamoon:profile-circle-light" className="currency-icon p-1" fontSize={60} color="#EB8153" />,
      value: dasboardData?.profilerate ?? 0,
      title: `${t("hprofileRate")}`,
    },
    {
      icon: (
        <Icon icon="material-symbols:reviews-outline" className="currency-icon p-2" fontSize={60} color="#EB8153" />
      ),
      value: dasboardData?.numberofreviews ?? 0,
      title: `${t("hreviewsprofile")}`,
    },
    {
      icon: <Icon icon="bxs:offer" className="currency-icon p-1" fontSize={60} color="#EB8153" />,
      value: dasboardData?.totalnumberofcreatedoffers ?? 0,
      title: `${t("htotOffers")}`,
    },
    {
      icon: <Icon icon="octicon:graph-16" className="currency-icon p-1" fontSize={60} color="#EB8153" />,
      value: dasboardData?.matchingbusinessescount ?? 0,
      title: `${t("hbusinessTotal")}`,
    },
    // {
    //   icon: <Icon icon="carbon:time" className="currency-icon p-1" fontSize={60} color="#EB8153" />,
    //   value: 500,
    //   title: "Average Offer Creation Time",
    // },
  ];
  return (
    <div>
      {loading && <Loader forProcess={true} />}
      <h2 className="mb-5">{t("sidebarItemDashboard")}</h2>

      {/* cards */}
      <div className="row">
        {cardArray?.map((item, index) => (
          <div className="col-xl-3 col-sm-6 px-2" key={index}>
            <div className="card card-coin ">
              <div className="card-body text-center">
                {item?.icon}
                <h2 className="text-black mb-2 font-w600">{item?.value}</h2>
                <p className="mb-0 fs-14">
                  {/* <span className="text-success me-1">45%</span> */}
                  {item?.title}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Business Graph */}
      <div className="d-flex gap-5">
        <div className="card card-coin ps-5 pt-3" style={{ width: "40%" }}>
          <h3>{t("sidebarItemOffers")}</h3>
          <div className="mx-auto ">
            <PieChat
              data={[
                { name: t("haccept"), count: 10 },
                { name: t("hreject"), count: 15 },
                { name: t("pending"), count: 20 },
              ]}
              colors={["#10439F", "#EB8153", "#B4B4B8"]}
              width={310}
            />
          </div>
        </div>
        <div className=" card card-coin px-3 pt-3" style={{ width: "60%" }}>
          <h3>{t("sidebarItemContracts")}</h3>
          <BarChartNoPadding
            height={460}
            data={[
              {
                contracttype: "IT",
                numberofcontractscompleted: 5,
                numberofcontractspending: 0,
              },
              {
                contracttype: "Escrow",
                numberofcontractscompleted: 3,
                numberofcontractspending: 2,
              },
              {
                contracttype: "Due Diligence",
                numberofcontractscompleted: 7,
                numberofcontractspending: 1,
              },
            ]}
          />
        </div>
      </div>

      <div className="card card-coin px-5 py-2">
        <h3>{t("highestIndustries")}</h3>
        <div className="">
          <TripleBarCharts data={revenue} />
        </div>
      </div>

      <div className="card card-coin ps-5 pt-3">
        <h3>{t("hdistributionIndustrie")}</h3>
        <div className="mx-auto ">
          <PieChat
            data={[
              { name: t("hgermany"), count: 14 },
              { name: "Canada", count: 18 },
              { name: t("hUSA"), count: 45 },
              { name: t("hkingdom"), count: 23 },
            ]}
            colors={["#10439F", "#EB8153", "#B4B4B8", "#FFC55A"]}
            // width={310}
          />
        </div>
      </div>
    </div>
  );
};

export default BuyerDashboard;
